import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {AppMsalAuthService} from "../../core/auth/authentication-service/app-msal-auth.service";

@Component({
  selector: 'app-mock-login',
  imports: [],
  templateUrl: './mock-login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mock-login.component.css'
})
export class MockLoginComponent {
  authService = inject(AppMsalAuthService);
}
